// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z8y7","controls":"styles_controls__Qr_cT","charLimit":"styles_charLimit__3Mxuz","input":"styles_input__3TDpq","send":"styles_send__2DnDN"};